import { listMatrixUserEmailsByRoleName, viewerRoleType } from "./commercialRoleAccess";
import {
  isConstructionLeadRoleType,
  isInspectorRoleType,
  isOspEngineeringRoleType,
} from "./projectLandingTabAccess";
import {
  getImpersonation,
  getViewerEmailFromStorage,
  isImpersonating,
  hasViewerOperationalAdminAccess,
} from "./userMatrixStorage";

function viewerMatchesRoleEmails(viewerEmail, roleName) {
  const emailsToCheck = new Set();
  const stored = String(viewerEmail || getViewerEmailFromStorage() || "")
    .trim()
    .toLowerCase();
  if (stored) emailsToCheck.add(stored);

  const imp = getImpersonation();
  if (imp?.email) {
    emailsToCheck.add(String(imp.email).trim().toLowerCase());
  }

  const roleEmails = listMatrixUserEmailsByRoleName(roleName).map((e) => e.toLowerCase());
  for (const em of emailsToCheck) {
    if (roleEmails.includes(em)) return true;
  }
  return false;
}

export function viewerHasInspectorRole(viewerEmail) {
  if (isInspectorRoleType(viewerRoleType(viewerEmail))) return true;
  return viewerMatchesRoleEmails(viewerEmail, "Inspector");
}

export function viewerHasConstructionLeadRole(viewerEmail) {
  if (isConstructionLeadRoleType(viewerRoleType(viewerEmail))) return true;
  return viewerMatchesRoleEmails(viewerEmail, "Construction Lead");
}

/** Roles that submit daily progress reports (inspectors and construction leads). */
export function viewerCanSubmitDailyProgressReports(viewerEmail) {
  return viewerHasInspectorRole(viewerEmail) || viewerHasConstructionLeadRole(viewerEmail);
}

export function viewerIsAssignedInspector(viewerEmail, inspectorValue) {
  const v = String(viewerEmail || getViewerEmailFromStorage() || "")
    .trim()
    .toLowerCase();
  const imp = getImpersonation();
  const impEmail = imp?.email ? String(imp.email).trim().toLowerCase() : "";
  const effectiveViewer = isImpersonating() && impEmail ? impEmail : v;
  const i = String(inspectorValue || "").trim().toLowerCase();
  if (!effectiveViewer || !i) return false;
  return effectiveViewer === i;
}

export function viewerCanReportExpansionProgress(viewerEmail, inspectorValue) {
  return (
    viewerIsAssignedInspector(viewerEmail, inspectorValue) ||
    viewerCanSubmitDailyProgressReports(viewerEmail)
  );
}

export function viewerHasOspEngineeringRole(viewerEmail) {
  return isOspEngineeringRoleType(viewerRoleType(viewerEmail));
}

export function canAccessInspectorAddReport(viewerEmail) {
  if (viewerCanSubmitDailyProgressReports(viewerEmail)) return true;
  if (viewerHasOspEngineeringRole(viewerEmail)) return true;
  if (isImpersonating()) return false;
  return hasViewerOperationalAdminAccess();
}
